import { Grid, Stack, Typography, useTheme } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Headline5 } from '../../../mui-custom/Headline5';
import { IconListedItem } from '../../../mui-custom/IconListedItem';
import { usePlanPriceCalculator } from '../../../components/PricingDetails';
import Check from '@mui/icons-material/Check';
import { RELAY_FACILITY_MANAGER } from '@api/v1';

export const AbonnementsSectionJanitor: React.FC = (): JSX.Element => {
	const { t } = useTranslation();
	const { palette } = useTheme();

	const benefits = [
		t('registration:janitor_abo_benefits_unlimited_orders'),
		t('registration:janitor_abo_benefits_unlimited_users'),
		t('registration:janitor_abo_benefits_unlimited_property_management'),
		t('admin:account_pricing_order_management_and_history'),
		t('registration:janitor_abo_benefits_coworker_management'),
		t('admin:account_pricing_termination_notice'),
		t('admin:account_pricing_support_feature')
	];

	return (
		<Stack sx={{ alignItems: 'center', gap: 4, py: 4, backgroundColor: palette.background.paper }}>
			<Stack sx={{ alignItems: 'center', gap: 1 }}>
				<Typography color={palette.primary.main}>
					{t('registration:starter_page_abo').toUpperCase()}
				</Typography>
				<Headline5>{t('registration:janitor_abo_headline')}</Headline5>
			</Stack>
			<Grid container>
				<Grid item xs={12} md={6} pr={2} container justifyContent={'end'}>
					<Grid>
						<JanitorPricingDetails />
					</Grid>
				</Grid>
				<Grid item xs={12} md={6} pl={2}>
					<Typography>
						{t('registration:janitor_abo_benefits_right_column').toUpperCase()}
					</Typography>
					{benefits.map((benefit, id) => (
						<IconListedItem key={id} small icon={<Check />} text={benefit} />
					))}
				</Grid>
			</Grid>
		</Stack>
	);
};

export const JanitorPricingDetails = () => {
	const { t } = useTranslation();
	const planPrices = usePlanPriceCalculator();
	const { palette } = useTheme();
	const price = planPrices[RELAY_FACILITY_MANAGER];
	return (
		<>
			<Stack
				sx={{ backgroundColor: (palette as any).infoShades4p }}
				py={2}
				pl={4}
				pr={10}
				gap={4}
				width={'fit-content'}
			>
				<Typography variant="h5">{t('admin:account_pricing_facility_manager')}</Typography>
				<Stack>
					<Stack direction={'row'} gap={1} alignItems={'center'}>
						<Typography variant="h5">{price}€</Typography>
						<Typography variant="body1">{t('registration:per_property')}</Typography>
					</Stack>
					<Typography variant="body2" color={palette.text.secondary}>
						{t('registration:plus_mwst')}
					</Typography>
				</Stack>
			</Stack>
		</>
	);
};
